// @flow
import React from "react";
import { get } from "lodash";
import { Svg } from "./styled-components";
import type { FlagProps } from "./types";

import * as Countries from "./countries";

export const Flag = ({ country, circular }: FlagProps) => {
  const FlagContent = get(Countries, country, false);

  return (
    FlagContent && (
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={circular ? "20" : "27.2"}
        height={circular ? "20" : "17"}
        viewBox={`0 0 ${circular ? "20 20" : "32 20"}`}
        circular={circular}
      >
        <FlagContent circular={circular} />
      </Svg>
    )
  );
};

Flag.defaultProps = {
  country: "",
  circular: false
};

// $FlowFixMe
export default React.memo(Flag);
